import DataAccess from './constants';
import { genfunction } from '../helpers';

const path = 'costrates'

export const apiCostRate = (costrateObj) => {

    var h = new Headers();
    h.append("Authorization", 'Basic ' + genfunction.EncodeBase64(DataAccess.userName + ':' + DataAccess.password));
    h.append('Content-Type', 'application/json');

    let gpName = costrateObj.groupname !== undefined && costrateObj.groupname.length > 0 ? costrateObj.groupname : "";
    let subGpName = costrateObj.subgroup !== undefined && costrateObj.subgroup.length > 0 ? costrateObj.subgroup : "";

    let url = DataAccess.apiUrl + path;

    if (gpName && gpName.length > 0) {
        url += "?GroupName=" + gpName;
    }

    if (gpName && gpName.length > 0 && subGpName && subGpName.length > 0) {
        url += "&SubGroupName=" + subGpName;
    }

    if (gpName && gpName.length == 0 && subGpName && subGpName.length > 0) {
        url += "?SubGroupName=" + subGpName;
    }

    const req = new Request(url, {
        method: 'GET',
        headers: h
    })

    return fetch(req);
}